// Pages/VincularCategoria/styled.ts
import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding: 1.5rem 0;

  @media (max-width: 768px) {
    padding: 1rem 0;
  }
`;

export const HeaderCard = styled.div`
  margin-bottom: 1.5rem;

  .card {
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  svg {
    color: #009ef7;
    flex-shrink: 0;
  }

  h4 {
    margin: 0 0 0.25rem 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #181c32;
  }

  p {
    margin: 0;
    font-size: 0.875rem;
    color: #7e8299;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    
    h4 {
      font-size: 1.1rem;
    }

    p {
      font-size: 0.813rem;
    }
  }
`;